import React from "react";
import "./FreeTrail.css";
import congrats from "../../assets/images/congrats.png";
import syncc from "../../assets/images/syncc.png";
import lockie from "../../assets/images/lockie.png";
import calend from "../../assets/images/calend.png";
import { useHistory } from "react-router-dom";
export const FreeTrailPage = () => {
  const history = useHistory();
  return (
    <div className="freetrailCard">
      <div className="freetrailCardInner">
        <div className="freeTrailheader">
          What to expect for your free 30-day trial
        </div>
        {/*<div className="freetrailpara" style={{ marginTop: "1rem" }}>
          <img className="free-trial-icons" src={syncc} alt="" />
          <span className="freetrailparablue">Sync</span> Sync your accounts
          today for up to date balances
        </div> */}
        <div className="freetrailpara" style={{ marginTop: "1rem" }}>
          <img className="free-trial-icons" src={lockie} alt="" />
          <div>
            <span className="freetrailparablue">Enjoy full access to </span>{" "}
            Desktop and Mobile Applications for currently active modules:
            <ul style={{ listStyle: "inside", marginBottom: "1rem" }}>
              <li className="freetrailparaList">Assets</li>
              <li className="freetrailparaList">Liabilities</li>
              <li className="freetrailparaList">
                {" "}
                WhenIDie (Part of the 4 D's)
              </li>
              <li className="freetrailparaList"> Inventory and Collectibles</li>
              <li className="freetrailparaList">
                {" "}
                90% off{" "}
                <a
                  style={{ textDecoration: "underline" }}
                  href="https://www.MyLegacyWall.com"
                  target="_blank">
                  MyLegacyWall.com
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="freetrailpara" style={{ marginTop: "1rem" }}>
          <img className="free-trial-icons" src={calend} alt="" />
          <span className="freetrailparablue">On day 30</span> you will receive
          a reminder your trial is ending soon. It is a easy to cancel anytime.
        </div>
        <div className="freetrailpara" style={{ marginTop: "8px" }}>
          <img className="free-trial-icons" src={congrats} alt="" />
          <span className="freetrailparablue">On day 31</span> Your trail has
          ended and access is suspended until you subscribe, which we have made
          very simple.
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}>
          <button
            className="savebutton"
            style={{
              textAlign: "center",
              marginTop: "2rem",
              fontSize: "18px",
              padding: "12px 40px",
            }}
            type="submit"
            onClick={() => {
              // history.push("/select-dashboard");
              history.push("/questioner");
            }}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
};
